import { Toast, Dialog } from 'vant';

export default {

    data() {
        return {
            status: 0,
            timer: null,
            // isClick: false,
            detailDatas: {} //详情对象
        };
    },

    mounted() {
        if (this.$route.query.memberId != undefined) {
            this.getSignUpActivityDetail();
        }

        

    },
    beforeDestroy() {

    },
    methods: {

        // 获取当前参与项目详情
        getSignUpActivityDetail: function () {
            // console.log(this.currentTime);
            this.$api.getSignUpActivityDetail({
                params: {
                    'activityId': this.$route.query.activityId + '',
                    'memberId': this.$route.query.memberId + '',
                },
                success: function (res) {
                    // console.log(res.data, "res.data");
                    this.detailDatas = res.data;
                    // 报名状态 0：即将开始 1：活动进行中 2：已结束 3：会员已报名
                    // if (res.data.signUpStatus == 0) {
                    //     this.getCouponRestTime();
                    // }

                }.bind(this),
                fail: function (res) {
                    console.log(":::fail", res)

                }
            })
        },
        btnSignUpKill() {
            // if (this.isClick) {

            //     Toast('禁止重复提交！');
            //     return;
            // }
            // this.isClick = true;
            this.getSignUpKill()
        },
        // 参与报名活动
        getSignUpKill: function () {
            this.$api.getSignUpKill({
                params: {
                    'activityId': this.$route.query.activityId + '',
                    'memberId': this.$route.query.memberId + '',
                },
                success: function (res) {
                    if (res.code == 0) {

                        // this.isClick = false;
                        Dialog({
                            title: '报名成功',
                            theme: 'round-button',
                        }).then(() => {
                            // on close
                            location.reload();
                        });

                    } else {
                        Dialog({
                            message: res.msg,
                            theme: 'round-button',
                        }).then(() => {
                            // on close
                            location.reload();
                        });
                    }



                }.bind(this),
                fail: function (res) {
                    console.log(":::fail", res)
                    Toast.success(res.msg);

                }
            })
        },






    }
};